import React from "react";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Typography, IconButton } from "@material-ui/core";

const ViewGroupIconButton = ({ classes, onClick, children, title }) => {
  return (
    <IconButton
      title={title}
      onClick={onClick}
      classes={{
        root: classes.iconButtonRoot,
      }}
    >
      <Typography color="secondary" className={classes.iconContainer}>
        {children}
      </Typography>
    </IconButton>
  );
};

ViewGroupIconButton.defaultProps = {
  title: "",
};

const styles = theme => ({
  iconButtonRoot: {
    padding: theme.spacing(1),
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
  },
  iconContainer: {
    display: "flex",
  },
});

export default compose(React.memo, withStyles(styles))(ViewGroupIconButton);
